import { Link } from "@mna/react";
import PageTitle from "features/PageTitle";
import { Trans } from "react-i18next";
import i18next from "i18next";
import { checkAndGetLocalStorageValue } from "../../../features/utils";

const confirmTitle = (
  <Trans i18nKey="findcareoption.confirm.confirm_title">
    Is this information correct?
  </Trans>
);

export default ({ actions, history, state }) => (
  <div className="standby-content standby-content-bottom-nav">
    <article className="standby-article">
      <div className="standby-center">
        <PageTitle titleText={confirmTitle} align="center" />
      </div>
      <div className="standby-input-info">
        <h2 className="fontWeight">
        <Trans i18nKey="findcareoption.confirm.confirm_subtitle1">
          {" "}
          Your Details:
        </Trans>
        </h2>
        <ul>
          {state.triageRequest.data && state.triageRequest.data.phone && (
            <li>{state.triageRequest.data.phone}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.email && (
            <li>{state.triageRequest.data.email}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.locationType === "1" ? (
            <li>
              {i18next.t(
                "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue2"
              )}
            </li>
          ) : (
            <li>
              {i18next.t(
                "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue3"
              )}
            </li>
          )}

          {state.triageRequest.data && state.triageRequest.data.hotelname && (
            <li>{state.triageRequest.data.hotelname}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.roomnumber && (
            <li>{state.triageRequest.data.roomnumber}</li>
          )}

          {state.triageRequest.data && state.triageRequest.data.address && (
            <li>{state.triageRequest.data.address}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.postalCode && (
            <li>{state.triageRequest.data.postalCode}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.country && (
            <li>{state.triageRequest.data.country}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.state && (
            <li>{state.triageRequest.data.state}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.city && (
            <li>{state.triageRequest.data.city}</li>
          )}
          {state.triageRequest.data && state.triageRequest.data.comments && (
            <li>{state.triageRequest.data.comments}</li>
          )}
        </ul>
      </div>
      <div className="standby-page-navigation standby-page-navigation-align-bottom">
        <button
          type="button"
          className="button standby-button standby-button-gradient standby-button-gradient-green"
          onClick={() => {
            var isPatientDetailsAdded = checkAndGetLocalStorageValue("isPatientDetailsAdded");
            localStorage.setItem("phonenumber", state.triageRequest.data.phone);
            localStorage.setItem("email", state.triageRequest.data.email);            
            actions.updateVendorContact();
            if (isPatientDetailsAdded !=="" && isPatientDetailsAdded == "false")
            {
              actions.updatePatientContact();
              localStorage.setItem("isPatientDetailsAdded", true);
            }

            history.push(`/find-care-options/concierge-care-result`);
          }}
        >
          <Trans i18nKey="findcareoption.confirm.confirm">Confirm</Trans>
        </button>
        <Link
          className="standby-button-back"
          to={`/find-care-options/concierge-care`}
        >
          <div className="icon">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 1024 1024"
            >
              <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
            </svg>
          </div>
          <Trans i18nKey="findcareoption.confirm.Edit_info">Edit info</Trans>
        </Link>
        <div className="standby-page-header standby-page-header-center">
          <Link
            className="standby-button-back"
            to={`/find-care-options/care-options`}
          >
            <div className="icon">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 1024 1024"
              >
                <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
              </svg>
            </div>
            <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">Cancel Request</Trans>
          </Link>
        </div>
      </div>
    </article>
  </div>
);
